<div class="slideshow">
  <div class="video-container">
    <video autoplay [muted]="true" loop playsinline id="myVideo">
      <source src="https://cdn.shopify.com/s/files/1/0926/9298/files/ira.mp4?v=1647986268" type="video/mp4">
    </video>
    <div class="content c-white">
      <p><span class="f-s-12">INTRODUCING</span></p>
      <p class="m-t-12 f-s-36 f-w-700">The Perfect Workout</p>
      <p class="m-t-20">Begins with the perfect stretch material</p>
      <p class="m-t-30 shop-btn"><span class="c-white f-s-14"  routerLink="/products/all">Shop now</span></p>
    </div>
  </div>
</div>

<div class="home-1-wrap">

  <div class="">
    <!-- Shop the collection div -->
    <div class="p-30 fx-row-wrap">
      <div class="fx-col gt-sm-fx-row fx-main-start fx-cross-start fx-fill-size fx-flex print-fx-gap-bottom-20px lt-md-fx-gap-bottom-20px gt-sm-fx-gap-right-20px"
        >
        <div class="card-wrap img-bg2 h-661 fx-fill-size print-fx-flex-49-in-col xs-fx-flex-49-in-col sm-fx-flex-50-in-col gt-sm-fx-flex-50"
          style="background-image: url('https://cdn.shopify.com/s/files/1/0926/9298/files/FORCEMAJEURE_LIGHTMARINE_4_1200x1600_ecbc368d-33f9-4ae8-ac62-c2e8205511e5.jpg?v=1644345376&width=1200');"
          >
          <mat-card appearance="outlined" class="light-block fx-row fx-main-start fx-cross-center">
            <div class="content c-white text-center">
              @if (!contentLoaded) {
                <ngx-skeleton-loader loadingText="Ziplingo" count="2"
                [theme]="{ 'border-radius': '0', width: '100px', height: '15px' }"></ngx-skeleton-loader>
              }
              @if (contentLoaded) {
                <p class="f-s-36 f-w-700 font-IBM">Womens</p>
              }
              <p>@if (contentLoaded) {
                <span class="m-t-12 font-IBM">Get a bonus plus for buying more that three
                products</span>
              }</p>
              @if (contentLoaded) {
                <p class="m-t-30 shop-btn font-IBM"  routerLink="/products/all"><a class="c-white f-s-14">Shop the
                Collection</a></p>
              }
            </div>
          </mat-card>
        </div>
        <div class="card-wrap img-bg2 h-661 fx-fill-size print-fx-flex-48-in-col xs-fx-flex-48-in-col sm-fx-flex-50-in-col gt-sm-fx-flex-50"
          style="background-image: url('https://cdn.shopify.com/s/files/1/0926/9298/files/STREAMLINE78_MARINE7_1200x1600_22474e3e-6864-4172-a333-32b79a0ccee6.jpg?v=1644345448&width=1200');"
          >
          <mat-card appearance="outlined" class="light-block fx-row fx-main-start fx-cross-center">
            <div class="content c-white text-center">
              @if (!contentLoaded) {
                <ngx-skeleton-loader loadingText="Ziplingo" count="2"
                [theme]="{ 'border-radius': '0', width: '100px', height: '15px' }"></ngx-skeleton-loader>
              }
              @if (contentLoaded) {
                <p class="f-s-36 f-w-700 font-IBM">Sweat Shirts</p>
              }
              <p>@if (contentLoaded) {
                <span class="m-t-12 font-IBM">Get a bonus plus for buying more that three
                products</span>
              }</p>
              @if (contentLoaded) {
                <p class="m-t-30 shop-btn font-IBM"  routerLink="/products/6"><a class="c-white f-s-14">Shop the
                Collection</a></p>
              }
            </div>
          </mat-card>
        </div>
      </div>
    </div>
    <hr style="margin:0px 28px; border-color:rgba(0,0,0,0.1)">
    <div class="p-30">
      <div class="fx-col">
        <p class="f-s-24 f-w-700">{{allItems[0]?.Category}}</p>
        <div class="m-t-10 fx-col gt-xs-fx-row fx-main-start fx-cross-start fx-fill-size fx-flex-100-in-col print-fx-gap-bottom-20px xs-fx-gap-bottom-20px gt-xs-fx-gap-right-20px"
          >
          @for (productImage of healthBeautyProduct; track productImage; let i = $index) {
            <div class="fx-col fx-main-center fx-cross-stretch fx-fill-size xs-fx-flex-100-in-col sm-fx-flex-100 gt-sm-fx-flex-32 print-fx-flex-32-in-col"
              >
              <div (mouseover)="mouseEnter(i)"
                (mouseout)="mouseOut(i)" class="p-relative cursor-pointer fx-col fx-main-center fx-cross-center fx-fill-size fx-flex-70-in-col lt-md-fx-flex-100-in-col"  id="parent">
                <img (click)="goToShop(productImage.ItemID)" [src]="env.imageUrl +productImage.ImageUrl" alt="" class="img-bg" [id]="'product'+i" style="width: 100% !important;">
                <!-- <img [src]="productImage.url" alt="" class="img-bg d-none" [id]="'products'+i" style="width: 100% !important;"> -->
                <div class="content fx-col fx-main-end fx-cross-stretch fx-fill">
                  <div class="p-absolute abs-width">
                    <button [id]="'btn'+i" class="shop-btn product-button d-none w-89 m-t-20 m-b-20 m-r-0 m-l-0"
                    mat-raised-button color="black"  (click)="handleProduct(productImage)">Quick Add</button>
                  </div>
                </div>
              </div>
              <div class="content m-t-20 fx-row fx-flex-10-in-col">
                <div class="fx-flex-70">
                  <p><span class="font-IBM">{{productImage.ProductName}}</span></p>
                  <p><span class="m-t-10 font-IBM">@if (productImage.oldPrice) {
                    <del>{{productImage.oldPrice}} </del>
                  }
                {{'$'+productImage.Price}}</span></p>
              </div>
              @if (productImage.oldPrice) {
                <div class="text-end m-t-10 fx-flex-30">
                  <p class="f-s-12 sale" color="white">Sale</p>
                </div>
              }
            </div>
          </div>
        }
      </div>
    </div>
  </div>
  <!-- Sweat suit -->
  <div class="p-30 fx-row">
    <div class="bg-white-smoke fx-col gt-sm-fx-row fx-main-center fx-cross-center fx-fill-size fx-flex">
      <div class="fx-col fx-main-center fx-cross-stretch fx-fill-size lt-md-fx-flex-100-in-col gt-sm-fx-flex-50 print-fx-flex-50-in-col">
        <img
          src="https://cdn.shopify.com/s/files/1/0926/9298/files/NEWBLACKOUTLEGGINGS_NAVY_1_085ee5dc-7e45-4d27-8a72-d75f18d4bb01_1080x.jpg?v=1600985773"
          alt="product-image" width="100%">
      </div>
      <div class="fx-col fx-main-center fx-cross-center fx-fill-size lt-md-fx-flex-100-in-col gt-sm-fx-flex-50 print-fx-flex-50-in-col">
        <div class="content text-center fx-col fx-main-center fx-cross-stretch fx-flex-50-in-col lt-md-fx-flex-100-in-col">
          <p class="m-t-12 f-s-36 f-w-700">The Sweat Suit</p>
          <p class="m-t-20">With award-winning moisture-wicking fabric.</p>
        </div>
        <div class="m-t-30 fx-row fx-main-center fx-cross-stretch fx-flex-50-in-col lt-md-fx-flex-100-in-col">
          <div class="fx-col fx-main-center fx-cross-center fx-flex-33">
            <div class="img-hover text-center">
              <img
                src="https://cdn.shopify.com/s/files/1/0926/9298/products/WORKOUTSPORTSBRA_BLACK_1_1200x1600_47939eb0-cf11-46fc-b6c3-a175511f4398.jpg?v=1600717663&width=650"
                alt="sports-costume" width="40%">
            </div>
            <p class="m-t-10 text-center f-s-14">Shoal Sports Bra in Black</p>
            <p class="m-t-10 f-s-14 a-hover"><a routerLink="/products/all">Shop now</a></p>
          </div>
          <div class="vl fx-flex-1"></div>
          <div class="fx-col fx-main-center fx-cross-center fx-flex-33">
            <div class="img-hover text-center">
              <img
                src="https://cdn.shopify.com/s/files/1/0926/9298/products/LIMITLESS7_8LEGGINGS_CARBON_5_1200x1600_4fd2ffb4-7ca0-4f10-b682-78ba6be776a4.jpg?v=1600723210&width=650"
                alt="sports-costume" width="40%">
            </div>
            <p class="m-t-10 text-center f-s-14">Tributary Leggings</p>
            <p class="m-t-10 f-s-14 a-hover"><a routerLink="/products/all">Shop now</a></p>
          </div>
          <div class="vl fx-flex-1"></div>
          <div class="fx-col fx-main-center fx-cross-center fx-flex-33">
            <div class="img-hover text-center">
              <img
                src="https://cdn.shopify.com/s/files/1/0926/9298/products/BLACKOUTLITELEGGING_DARKGREENMARL_4_1200x1600_15f09cf0-893a-4085-af87-55b1dfaa9ce9.jpg?v=1602882712&width=650"
                alt="sports-costume" width="40%">
            </div>
            <p class="m-t-10 text-center f-s-14">Tundra Leggings in Dark Green</p>
            <p class="m-t-10 f-s-14 a-hover"><a routerLink="/products/all">Shop now</a></p>
          </div>
          <div class="vl fx-flex-1"></div>
        </div>
        <button class="shop-btn product-button c-white" mat-raised-button color="black"  routerLink="/products/all">Shop the collection</button>
      </div>
    </div>
  </div>
  <hr style="margin:0px 28px; border-color:rgba(0,0,0,0.1)">
  <!-- Collections -->
  <div class="p-30">
    <div class="fx-col">
      <p class="f-s-24 f-w-700">Collections</p>
      <div class="m-t-10 fx-col gt-xs-fx-row fx-main-start fx-cross-start fx-fill-size fx-flex-in-col print-fx-gap-bottom-20px xs-fx-gap-bottom-20px gt-xs-fx-gap-right-20px"
        >
        <div class="fx-col fx-main-center fx-cross-stretch fx-fill-size xs-fx-flex-100-in-col sm-fx-flex-100 gt-sm-fx-flex-33 print-fx-flex-33-in-col">
          <div class="img-hover text-center">
            <img
              src="https://cdn.shopify.com/s/files/1/0926/9298/products/LIMITLESS7_8LEGGINGS_CARBON_5_1200x1600_4fd2ffb4-7ca0-4f10-b682-78ba6be776a4_540x.jpg?v=1600723210"
              alt="Leggings" width="100%">
          </div>
          <p class="f-s-18 f-w-700 m-t-10">Leggings</p>
        </div>
        <div class="fx-col fx-main-center fx-cross-stretch fx-fill-size xs-fx-flex-100-in-col sm-fx-flex-100 gt-sm-fx-flex-33 print-fx-flex-33-in-col">
          <div class="img-hover text-center">
            <img
              src="https://cdn.shopify.com/s/files/1/0926/9298/products/MARVELSPORTSBRA_CARBON_1_1200x1600_115127f6-557f-43bd-bf53-8db8bc9ecea8_540x.jpg?v=1600717912"
              alt="Leggings" width="100%">
          </div>
          <p class="f-s-18 f-w-700 m-t-10">Sports Bras</p>
        </div>
        <div class="fx-col fx-main-center fx-cross-stretch fx-fill-size xs-fx-flex-100-in-col sm-fx-flex-100 gt-sm-fx-flex-33 print-fx-flex-33-in-col">
          <div class="img-hover text-center">
            <img
              src="https://cdn.shopify.com/s/files/1/0926/9298/products/WRPUFFA_JACKET_LIGHTGREYMARL_271_1200x1600_14b13e56-441c-44f3-abe4-68afbc11116f_540x.jpg?v=1601329276"
              alt="Leggings" width="100%">
          </div>
          <p class="f-s-18 f-w-700 m-t-10">Men's Jackets</p>
        </div>
      </div>
    </div>
  </div>
  <!-- Performance div -->
  <div class="m-t-20">
    <div class="fx-col">
      <div class="bg-img p-relative fx-col fx-main-center fx-cross-stretch fx-flex-50-in-col">
        <img src="https://cdn.shopify.com/s/files/1/0926/9298/files/Block_02.jpg?v=1600977240&width=1512" alt="image">
        <div class="content p-abs c-white">
          <div class="p-relative p-content-div">
            <p><span class="f-s-12">OUR VALUES</span></p>
            <p class="m-t-12 f-s-36 f-w-700">Performance</p>
            <p class="m-t-20 w-35">Everything we do at Energy Well is guided by a commitment to unlocking the highest
            performance within our customers.</p>
            <p class="m-t-30 shop-btn"  routerLink="/products/all"><a class="c-white f-s-14">Learn More</a></p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <hr style="margin:0px 28px; border-color:rgba(0,0,0,0.1)">
  <!-- Quarterly Packs  this.allItems[0].Category-->
  <div class="p-30">
    <div class="fx-col">
      <p class="f-s-24 f-w-700">{{allItems[1]?.Category}}</p>
      <div class="m-t-10 fx-col gt-xs-fx-row fx-main-start fx-cross-start fx-fill-size fx-flex-100-in-col print-fx-gap-bottom-20px xs-fx-gap-bottom-20px gt-xs-fx-gap-right-20px"
        >
        @for (productImage of quarterlyPacksProduct; track productImage; let i = $index) {
          <div class="fx-col fx-main-center fx-cross-stretch fx-fill-size xs-fx-flex-100-in-col sm-fx-flex-100 gt-sm-fx-flex-32 print-fx-flex-32-in-col"
            >
            <div (mouseover)="mouseEnter(i+4)"
              (mouseout)="mouseOut(i+4)" class="p-relative cursor-pointer fx-col fx-main-center fx-cross-center fx-fill-size fx-flex-70-in-col lt-md-fx-flex-100-in-col" >
              <img (click)="goToShop(productImage.ItemID)" [src]="env.imageUrl +productImage.ImageUrl" alt="" class="img-bg" [id]="'product'+(i+4)"
                style="width: 100% !important;">
              <div class="content fx-col fx-main-end fx-cross-stretch fx-fill">
                <div class="p-absolute abs-width">
                  <button [id]="'btn'+(i+4)" class="shop-btn product-button d-none w-89 m-t-20 m-b-20 m-r-0 m-l-0"
                  mat-raised-button color="black"   (click)="handleProduct(productImage)">Quick Add</button>
                </div>
              </div>
            </div>
            <div class="content m-t-20 fx-row fx-flex-10-in-col">
              <div class="fx-flex-70">
                <p><span class="font-IBM">{{productImage.ProductName}}</span></p>
                <p><span class="m-t-10 font-IBM">@if (productImage.oldPrice) {
                  <del>{{productImage.oldPrice}} </del>
                }
              {{'$'+productImage.Price}}</span></p>
            </div>
            @if (productImage.oldPrice) {
              <div class="text-end m-t-10 fx-flex-30">
                <p class="f-s-12 sale" color="white">Sale</p>
              </div>
            }
          </div>
        </div>
      }
    </div>
  </div>
</div>
<!-- Slider -->
<div class="text-section">
  <div class="main-slider">
    <swiper-container class="swiper-container h-100" [appSwiper]="config" init="false">
      @for (slide of slider; track slide) {
        <swiper-slide class="swiper-slide p-relative">
          <img [src]="slide.image" loading="lazy" class="slide-item before-after-slides slider-img"/>
          <div class="content p-abs top-0 c-white">
            <div class="p-relative top-left">
              <p class="m-t-12 f-s-36 f-w-700">{{slide.title}}</p>
              <p class="m-t-20">{{slide.subtitle}}</p>
              <button class="shop-btn product-button p-fixed c-white" mat-raised-button color="black"  routerLink="/products/all">Shop the collection</button>
            </div>
          </div>
        </swiper-slide>
      }
      <!-- <div class="swiper-pagination white"></div> -->
      <div slot="container-end" class="swiper-button-prev"></div>
      <div slot="container-end" class="swiper-button-next"></div>
    </swiper-container>
  </div>
</div>
<!-- this.allItems[2].Category -->
@if (shopPacksProduct.length > 0) {
  <div class="p-30">
    <div class="fx-col">
      <p class="f-s-24 f-w-700">{{allItems[2]?.Category}}</p>
      <div class="m-t-10 fx-col gt-xs-fx-row fx-main-start fx-cross-start fx-fill-size fx-flex-100-in-col print-fx-gap-bottom-20px xs-fx-gap-bottom-20px gt-xs-fx-gap-right-20px"
        >
        @for (productImage of shopPacksProduct; track productImage; let i = $index) {
          <div class="fx-col fx-main-center fx-cross-stretch fx-fill-size xs-fx-flex-100-in-col sm-fx-flex-100 gt-sm-fx-flex-32 print-fx-flex-32-in-col"
            >
            <div (mouseover)="mouseEnter(i+10)"
              (mouseout)="mouseOut(i+10)" class="p-relative cursor-pointer fx-col fx-main-center fx-cross-center fx-fill-size fx-flex-70-in-col lt-md-fx-flex-100-in-col"  id="parent">
              <img (click)="goToShop(productImage.ItemID)" [src]="env.imageUrl +productImage.ImageUrl" alt="" class="img-bg" [id]="'product'+(i+10)" style="width: 100% !important;">
              <!-- <img [src]="productImage.url" alt="" class="img-bg d-none" [id]="'products'+i" style="width: 100% !important;"> -->
              <div class="content fx-col fx-main-end fx-cross-stretch fx-fill">
                <div class="p-absolute abs-width">
                  <button [id]="'btn'+(i+10)" class="shop-btn product-button d-none w-89 m-t-20 m-b-20 m-r-0 m-l-0"
                  mat-raised-button color="black"   (click)="handleProduct(productImage)">Quick Add</button>
                </div>
              </div>
            </div>
            <div class="content m-t-20 fx-row fx-flex-10-in-col">
              <div class="fx-flex-70">
                <p><span class="font-IBM">{{productImage.ProductName}}</span></p>
                <p><span class="m-t-10 font-IBM">@if (productImage.oldPrice) {
                  <del>{{productImage.oldPrice}} </del>
                }
              {{'$'+productImage.Price}}</span></p>
            </div>
            @if (productImage.oldPrice) {
              <div class="text-end m-t-10 fx-flex-30">
                <p class="f-s-12 sale" color="white">Sale</p>
              </div>
            }
          </div>
        </div>
      }
    </div>
  </div>
</div>
}
<!-- the new collection -->
<div class="m-t-20">
  <div class="fx-col">
    <div class="bg-img p-relative fx-col fx-main-center fx-cross-stretch fx-flex-50-in-col">
      <img src="https://cdn.shopify.com/s/files/1/0926/9298/files/Banner_03.jpg?v=1600973446&width=1512" alt="image">
      <div class="content p-abs c-white">
        <div class="p-relative p-content-div">
          <p><span class="f-s-12">INTRODUCING</span></p>
          <p class="m-t-12 f-s-36 f-w-700">The New Collection</p>
          <p class="m-t-20 w-35">Sustainable activewear inspired by the real lives and real bodies of our customers.</p>
          <p class="m-t-30 shop-btn"  routerLink="/products/all"><a class="c-white f-s-14">Shop now</a></p>
        </div>
      </div>
    </div>
  </div>
</div>
<hr style="margin: 40px 28px 0px 28px; border-color:rgba(0,0,0,0.1)">
<!-- social -->
<div class="p-30">
  <div class="fx-col">
    <p class="f-s-24 f-w-700">Social</p>
    <div class="m-t-10 fx-col gt-xs-fx-row fx-main-start fx-cross-start fx-fill-size fx-flex-100-in-col print-fx-gap-bottom-20px xs-fx-gap-bottom-20px gt-xs-fx-gap-right-20px"
      >
      <div class="fx-col fx-main-center fx-cross-stretch fx-fill-size xs-fx-flex-100-in-col sm-fx-flex-100 gt-sm-fx-flex-33 print-fx-flex-33-in-col">
        <div class=" text-center">
          <img
            src="https://cdn.shopify.com/s/files/1/0926/9298/files/BTN01_2x_234e83a8-4a87-4dac-a89b-1c7eb62a2f9e_540x.png?v=1600987056"
            alt="Leggings" width="100%">
        </div>
        <p class="f-s-14 f-w-400 m-t-10">We've just launched our newest pair of seamless tights. Pictured here and in stores soon.</p>
      </div>
      <div class="fx-col fx-main-center fx-cross-stretch fx-fill-size xs-fx-flex-100-in-col sm-fx-flex-100 gt-sm-fx-flex-33 print-fx-flex-33-in-col">
        <div class=" text-center">
          <img
            src="https://cdn.shopify.com/s/files/1/0926/9298/files/BTN03_2x_b8612da0-9555-44d0-a972-fa1fa9c62f77_540x.png?v=1600987024"
            alt="Leggings" width="100%">
        </div>
        <p class="f-s-14 f-w-400 m-t-10">Our newest line of tights come in navy and black and are sure to get you running.</p>
      </div>
      <div class="fx-col fx-main-center fx-cross-stretch fx-fill-size xs-fx-flex-100-in-col sm-fx-flex-100 gt-sm-fx-flex-33 print-fx-flex-33-in-col">
        <div class=" text-center">
          <img
            src="https://cdn.shopify.com/s/files/1/0926/9298/files/FLEXTANK_WHITE_2.jpg?crop=center&height=300&v=1600985712&width=300"
            alt="Leggings" width="100%">
        </div>
        <p class="f-s-14 f-w-400 m-t-10">Celebrating Mondays that get us moving - from the track to the pool.</p>
      </div>
    </div>
  </div>
</div>
</div>
</div>
